import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import ShopGoodsPage from './ShopGoodsPage';
import { useAppDispatch } from '../../store';
import { setLastShopTab } from '../../store/main/actionCreators';

const ShopGoods = () => {
  const dispatch = useAppDispatch();
  const { curProject } = useSelector((state) => state.main);
  const curProjectName = curProject?.name;
  const { curBot } = useSelector((state) => state.bot);
  // const curProjectName = 'mts-true-summer24-serverless221';

  useEffect(() => {
    dispatch(setLastShopTab('/shop/goods'));
    // eslint-disable-next-line
  }, []);

  return <ShopGoodsPage slug={curProjectName || ''} base={curBot.base || ''} />;
};

export default ShopGoods;
